import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';
import { trackEvent } from '../../utils/posthog';

const Footer: React.FC = () => {
  const handleLinkClick = (linkName: string, category: string) => {
    trackEvent('footer_link_click', {
      link_name: linkName,
      category: category
    });
  };

  const handleSocialClick = (platform: string) => {
    trackEvent('social_link_click', {
      platform: platform,
      location: 'footer'
    });
  };

  return (
    <footer className="bg-white border-t border-gray-100 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center mb-4" onClick={() => handleLinkClick('logo', 'main')}>
              <Logo />
            </Link>
            <p className="text-gray-600 text-sm mb-4">
              Finding the right college shouldn't be overwhelming. We simplify the process with data-driven recommendations.
            </p>
          </div>
          
          <div>
            <h3 className="text-gray-800 font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/features" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('features', 'product')}
                >
                  Features
                </Link>
              </li>
              <li>
                <Link 
                  to="/pricing" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('pricing', 'product')}
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link 
                  to="/how-it-works" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('how_it_works', 'product')}
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link 
                  to="/faq" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('faq', 'product')}
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-gray-800 font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/college-database" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('college_database', 'resources')}
                >
                  College Database
                </Link>
              </li>
              <li>
                <Link 
                  to="/help" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('help_center', 'resources')}
                >
                  Help Center
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('blog', 'resources')}
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-gray-800 font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/about-us" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('about_us', 'company')}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('contact', 'company')}
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('privacy_policy', 'company')}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-use" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('terms_of_use', 'company')}
                >
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link 
                  to="/disclaimer" 
                  className="text-gray-600 hover:text-[#7B4AE2] text-sm"
                  onClick={() => handleLinkClick('disclaimer', 'company')}
                >
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-100 mt-8 pt-8 flex flex-col-reverse md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mt-4 md:mt-0">
            &copy; {new Date().getFullYear()} 11thadmissions.com. All rights reserved.
          </p>
          
          <div className="flex items-center space-x-4">
            <a 
              href="https://twitter.com/11thadmissions" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#7B4AE2]"
              onClick={() => handleSocialClick('twitter')}
            >
              Twitter
            </a>
            <a 
              href="https://instagram.com/11thadmissions" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#7B4AE2]"
              onClick={() => handleSocialClick('instagram')}
            >
              Instagram
            </a>
            <a 
              href="https://linkedin.com/company/11thadmissions" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#7B4AE2]"
              onClick={() => handleSocialClick('linkedin')}
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;